@if (this.analysisStateService.exports.hasValue()) {
  @let exports = this.analysisStateService.exports.value();

  <!-- no exports -->
  @if (exports.length === 0) {
    <p class="text-content-secondary">
      {{ 'ANALYSIS.EXPORT.NO_EXPORTS' | translate }}
    </p>
  }

  <!-- export list -->
  <div class="max-h-80 overflow-y-auto">
    @for (export of exports; track export.id) {
      <div class="flex items-center gap-2.5">
        <mat-checkbox
          [checked]="selectedExportId() === export.id"
          [disabled]="export.status !== AnalysisExportStatus.COMPLETED"
          (change)="
            selectedExportId.set(
              selectedExportId() === export.id ? undefined : export.id
            )
          "
          class="shrink-0"
        />

        <!-- loading export -->
        @let exportIsLoading =
          export.status === AnalysisExportStatus.PENDING ||
          export.status === AnalysisExportStatus.PROCESSING;
        @if (exportIsLoading) {
          <pm-icon
            [icon]="loaderIcon"
            size="sm"
            class="text-content-secondary animate-spin shrink-0"
          />
        }

        <!-- failed export -->
        @if (export.status === AnalysisExportStatus.FAILED) {
          <pm-icon
            [icon]="errorIcon"
            size="sm"
            class="text-content-critical shrink-0"
          />
        }

        <span
          class="flex-1 text-sm text-content-interactive-subdued truncate min-w-0"
        >
          {{ export.fileName ?? '' }}
        </span>

        <span class="text-xs text-content-interactive-subdued shrink-0">
          {{
            this.dateUtilsService.formatDateTimeBasedOnLanguage(
              export.createdAt
            )
          }}
        </span>
      </div>
    }
  </div>
}
